<template>
  <div>
    <header id="menu">
      <nav class="navbar navbar-default navbar-static-top" role="navigation">
        <div class="container">
          <div class="row">
            <div class="col-xs-6">
              <div class="small left">
                <router-link to="/">
                  <span>Dados Abertos</span>
                </router-link>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="small right">
                <a href="https://www.santos.sp.gov.br/" class="navbar-brand">
                  <img src="../../assets/css/img/LogoPMS.svg" height="40" alt="Logo Prefeitura Municipal de Santos">
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <div class="container-fluid" id="conteudo">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <footer>
      <rodape />
    </footer>
    <noscript>
      <p>Este site requer JavaScript para funcionar corretamente. Por favor, ative-o nas configurações do seu navegador.</p>
    </noscript>
  </div>
</template>

<script>
import rodape from '@/components/footer'
import { TOGGLE_LOADING } from '../../store/modules/receitas_despesas/types'
import { Accessibility } from 'accessibility'

export default {
  name: 'index',
  components: {
    rodape
  },
  mounted() {
    const options = {
      labels: {
        resetTitle: 'Reiniciar',
        closeTitle: 'Fechar',
        menuTitle: 'Acessibilidade',
        increaseText: 'Aumentar texto',
        decreaseText: 'Diminuir texto',
        increaseTextSpacing: 'Aumentar espaçamento',
        decreaseTextSpacing: 'Diminuir espaçamento',
        invertColors: 'Alto contraste',
        grayHues: 'Tons de cinza',
        underlineLinks: 'Sublinhar links',
      },
      modules: {
        bigCursor: false,
        readingGuide: false,
        disableAnimations: false,
        textToSpeech: false,
        speechToText: false,
        increaseLineHeight: false,
        decreaseLineHeight: false
      },
      hotkeys: {
        enabled: false
      },
      session: {
        persistent: false
      },
    }

    const instance = new Accessibility(options);

    setTimeout(() => {
      if (instance.menuInterface) {
        instance.menuInterface.increaseText = function () {
          if (instance.sessionState.textSize < 5) {
            instance.alterTextSize(true);
          } else {
            instance.resetTextSize();
          }
        }
        instance.menuInterface.decreaseText = function () {
          if (instance.sessionState.textSize <= 5 && instance.sessionState.textSize > -2) {
            instance.alterTextSize(false);
          } else {
            instance.resetTextSize();
          }
        }

        instance.menuInterface.increaseTextSpacing = function () {
          if (instance.sessionState.textSpace < 5) {
            instance.alterTextSpace(true);
          } else {
            instance.resetTextSpace();
          }
        }
        instance.menuInterface.decreaseTextSpacing = function () {
          if (instance.sessionState.textSpace <= 5 && instance.sessionState.textSpace > -3) {
            instance.alterTextSpace(false)
          } else {
            instance.resetTextSpace();
          }  
        }
      } else {
        console.warn("Não foi possivel carregar o menuInterface")
      }
    }, 500);
  },
  beforeCreate() {
    this.$store
      .dispatch('loadReceitasProprias')
      .then(() => { })
      .catch(() => {
        this.$toastr.e(
          'Houve um problema ao carregar as informações de Receitas do ano atual. A página estará com as informações indisponíveis.'
        )
      })

    this.$store
      .dispatch('loadDetalhamentoDespesas')
      .then(() => { })
      .catch(() => {
        this.$toastr.e(
          'Houve um problema ao carregar as informações de Despesas do ano atual. A página estará com as informações indisponíveis.'
        )
      })

    this.$store
      .dispatch('loadGrupoDespesas')
      .then(() => { })
      .catch(() => {
        this.$toastr.e(
          'Houve um problema ao carregar as informações de Despesas por grupo. A página estará com as informações indisponíveis.'
        )
      })

    this.$store
      .dispatch('loadFuncaoSubfuncao')
      .then(() => { })
      .catch(() => {
        this.$toastr.e(
          'Houve um problema ao carregar as informações de Despesas por função e subfunção. A página estará com as informações indisponíveis.'
        )
      })

    this.$store.commit(TOGGLE_LOADING)

    this.$store
      .dispatch('loadDespesasDetalhadas')
      .then(() => { })
      .catch(error => {
        this.$toastr.e(
          'Houve um problema ao carregar as informações de Despesas detalhadas. A página estará com as informações indisponíveis.'
        )
      })
      .finally(() => this.$store.commit(TOGGLE_LOADING))
  }
}
</script>

<style scoped>
footer {
  position: relative;
}

a>span {
  display: block;
  color: #dcf9c1;
  font-size: 2.8em;
  font-weight: 900;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: inherit;
  line-height: 1.1;
}
</style>



// WEBPACK FOOTER //
// src/views/public/index.vue